import styled from '@emotion/styled';
import { forwardRef, TextareaHTMLAttributes } from 'react';
import { Color } from '@diritto/common/style/color';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(({ className, ...rest }, ref) => (
  <StyledTextArea ref={ref} className={className} {...rest} />
));

TextArea.displayName = 'TextArea';

const StyledTextArea = styled.textarea`
  border: none;
  resize: none;
  font-family: inherit;
  width: 100%;
  padding: 0;
  margin: 0;
  display: block;

  appearance: none;

  &::placeholder {
    color: ${Color.Gray500};
  }

  &:focus {
    outline: none;
  }
`;
